// Browser sessions that let <img>, <iframe> and <video> open protected files (HttpOnly cookies set by the API).
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/session`;

const withTimeout = (promise, ms = 2500) => Promise.race([promise, new Promise(r => setTimeout(r, ms))]);

export const refreshFileSession = () => {
  const token = localStorage.getItem('token');
  const calls = [fetch(`${BASE}/site`, { credentials: 'include' })];
  if (token) {
    calls.push(fetch(`${BASE}/auth`, { method: 'POST', credentials: 'include', headers: { Authorization: `Bearer ${token}` } }));
  }
  return withTimeout(Promise.allSettled(calls));
};

export const clearFileSession = () => fetch(`${BASE}/auth`, { method: 'DELETE', credentials: 'include' }).catch(() => {});
